<template>
    <el-row class="info paquetes-section" :gutter="20">
        <el-col class="is-justify-content-center is-flex pt-6 paquetes-header" :span="24">
            <h1 class="title is-2 text-primary info-title has-text-centered" style="font-weight: normal;">¡ESTOS SON NUESTROS <b>PAQUETES</b>!</h1>
        </el-col>
        <el-col class="is-justify-content-center is-flex description paquetes-description" :span="24">
            <div class="my-subtitle is-size-2 has-text-light has-text-centered pb-6">
                <p class="mb-0" style="margin-bottom: 0 !important; line-height: .7;"> TE INVITAMOS A DESCUBRIR LOS</p>
                <b class="is-size-2 mb-0" style=""> PAQUETES QUE TENEMOS PARA TI</b>. 
                <br>
                <p class="pt-2" style="font-size: 1.5rem;">Selecciona el que más te convenga <b> y se adapte a tus necesidades</b>.</p>
            </div>    
        </el-col>
        <!-- <div class="container-fluid"> -->
            <el-col class="card-packages" :span="24">
                <el-row>
                    <el-col :xs="24" :sm="{span: 18, offset: 3}" :md="{span: 8, offset: 0}" :lg="{span: 6, offset: 0}" :xl="{span: 6, offset: 0}" class="card-basic px-3 py-5 my-5">
                        <div class="pt-5 pb-5 has-text-white" style="background: #46A4D7; background: linear-gradient(rgb(161 89 37), rgb(129 99 53)); border-radius: 10px;">
                            <div class="mb-4 is-justify-content-center is-flex" style="background-color: white; position: relative; height: 80px;">
                                <img class="w-65 paquete-img" src="/imgs/tucan.png" alt="VetSolutions">
                            </div>
                            <div class="ml-5 mr-5">
                                <h5 class="subtitle is-5 mb-2" style="font-weight: normal; color: white !important;">PAQUETE <b class="has-text-white" style="font-size: 1.7rem;">INDIVIDUAL</b></h5>
                                
                                <p class="mb-2">Incluye:</p>
                                <p style="white-space: pre-line;">{{selectPackage.individual.description}}</p><br>
                                <!-- <span>Costo: <b style="font-size: 1.5rem;">{{ filterCurrencyFormat(selectPackage.basic.price) }}</b></span><br> -->
                                <el-button class="btn-primary mt-2" size="large" @click="goTo('register')">Ver información completa</el-button>
    
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="{span: 18, offset: 3}" :md="{span: 8, offset: 0}" :lg="{span: 6, offset: 0}" :xl="{span: 6, offset: 0}" class="card-basic px-3 py-5 my-5">
                        <div class="pt-5 pb-5 has-text-white" style="background: #46A4D7; background: linear-gradient(180deg, #46A4D7, #1A85C1); border-radius: 10px;">
                            <div class="mb-4 is-justify-content-center is-flex" style="background-color: white; position: relative; height: 80px;">
                                <img class="w-50 paquete-img" src="/imgs/rabbit.png" alt="VetSolutions">
                            </div>
                            <div class="ml-5 mr-5">
                                <h5 class="subtitle is-5 mb-2" style="font-weight: normal; color: white !important;">PAQUETE <b class="has-text-white" style="font-size: 1.7rem;">BÁSICO</b></h5>
                                
                                <p class="mb-2">Incluye:</p>
                                <p style="white-space: pre-line;">{{selectPackage.basic.description}}</p>
                                <!-- <span>Costo: <b style="font-size: 1.5rem;">{{ filterCurrencyFormat(selectPackage.basic.price) }}</b></span><br> -->
                                <el-button class="btn-primary mt-2" size="large" @click="goTo('register')">Ver información completa</el-button>
    
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="{span: 18, offset: 3}" :md="{span: 8, offset: 0}" :lg="{span: 6, offset: 0}" :xl="{span: 6, offset: 0}" class="card-standard px-3 py-5 my-5">
                        <div class="pt-5 pb-5 has-text-white" style="background: #9D9D9D; background: linear-gradient(180deg, #9D9D9D, #565656); border-radius: 10px;">
                            <div class="mb-4 is-justify-content-center is-flex" style="background-color: white; position: relative; height: 80px;">
                                <img class="w-40 paquete-img" src="/imgs/cat.png" alt="VetSolutions">
                            </div>
                            <div class="ml-5 mr-5">
                                <h5 class="subtitle is-5 mb-2" style="font-weight: normal; color: white !important;">PAQUETE <b class="has-text-white" style="font-size: 1.7rem;">ESTÁNDAR</b></h5>
                                
                                <p class="mb-2">Incluye:</p>
                                <p style="white-space: pre-line;">{{selectPackage.standard.description}}</p>
                                <el-button class="btn-primary mt-2" size="large" @click="goTo('register')">Ver información completa</el-button>
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="{span: 18, offset: 3}" :md="{span: 8, offset: 0}" :lg="{span: 6, offset: 0}" :xl="{span: 6, offset: 0}" class="card-premium px-3 py-5 my-5">
                        <div class="pt-5 pb-5 has-text-white" style="background: #EBBF3C; background: linear-gradient(180deg, #EBBF3C, #A17C13); border-radius: 10px;">
                            <div class="mb-4 is-justify-content-center is-flex" style="background-color: white; position: relative; height: 80px;">
                                <img class="w-60 paquete-img" src="/imgs/dog.png" alt="VetSolutions">
                            </div>
                            <div class="ml-5 mr-5">
                                <h5 class="subtitle is-5 mb-2" style="font-weight: normal; color: white !important;">PAQUETE <b class="has-text-white" style="font-size: 1.7rem;">PREMIUM</b></h5>
                                
                                <p class="mb-2">Incluye:</p>
                                <p style="white-space: pre-line;">{{selectPackage.premium.description}}</p>
                                <el-button class="btn-primary mt-2" size="large" @click="goTo('register')">Ver información completa</el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-col>
        <!-- </div> -->
    </el-row>
</template>

<script setup>
    import { useRouter } from 'vue-router';
    import {onMounted, ref, reactive, onBeforeMount } from 'vue';
    import apiClient from '@/api/apiClient';

    const router = useRouter();

    const goTo = (name) => {
       router.push({ name });
    }

    onBeforeMount(async() => {
        getPackages();
    });

    const packages      = ref([]);
    const selectPackage = ref({
        individual: {
            id: '',
            sku: 'vetsol-individual',
            price: 0,
            name: '',
            description: ''
        },
        basic: {
            id: '',
            sku: 'vetsol-basic',
            price: 0,
            name: '',
            description: ''
        },
        standard: {
            id: 0,
            sku: 'vetsol-standard',
            price: 0,
            name: '',
            description: ''
        },
        premium: {
            id: '',
            sku: 'vetsol-premium',
            price: 0,
            name: '',
            description: ''
        }
    });

    const getPackages = async() => {
        try {
            const response = await apiClient.get('/payments/getPackages');
            packages.value = response.data.data;
            packages.value.forEach(p => {
                if (p.sku == selectPackage.value.basic.sku) {
                    selectPackage.value.basic.id = p.id;
                    selectPackage.value.basic.name = p.name;
                    selectPackage.value.basic.price = p.price;
                    selectPackage.value.basic.sku = p.sku;
                    selectPackage.value.basic.description = p.description;
                }
                if (p.sku == selectPackage.value.individual.sku) {
                    selectPackage.value.individual.id = p.id;
                    selectPackage.value.individual.name = p.name;
                    selectPackage.value.individual.price = p.price;
                    selectPackage.value.individual.sku = p.sku;
                    selectPackage.value.individual.description = p.description;
                }
                if (p.sku == selectPackage.value.standard.sku) {
                    selectPackage.value.standard.id = p.id;
                    selectPackage.value.standard.name = p.name;
                    selectPackage.value.standard.price = p.price;
                    selectPackage.value.standard.sku = p.sku;
                    selectPackage.value.standard.description = p.description;
                }
                if (p.sku == selectPackage.value.premium.sku) {
                    selectPackage.value.premium.id = p.id;
                    selectPackage.value.premium.name = p.name;
                    selectPackage.value.premium.price = p.price;
                    selectPackage.value.premium.sku = p.sku;
                    selectPackage.value.premium.description = p.description;
                }
            });
        } catch (error) {
            // errorMessage.value = error.response.data.msg
        } finally {
            
        }
    };
</script>

<style scoped>
    .paquetes-section {
        background-color: #C2EBFF;
        background-image: url('@/assets/image/home/banner2.png');
        background-repeat: no-repeat;
        background-position: top center;
        background-size: cover;
        padding-top: 2rem;
        padding-bottom: 6rem;
    }
    .paquetes-header,
    .paquetes-description {
        background-color: transparent !important;
    }
    .card-packages {
        padding: 2rem 0;
    }
    .paquete-img {
        position: absolute;
        bottom: 0px !important;
        width: 40% !important;
    }
    .w-65 {
        width: 65% !important;
    }
    .w-50 {
        width: 50% !important;
    }
    .w-40 {
        width: 40% !important;
    }
</style>